import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import TransactionSettingBox from '../TransactionSettingBox'
import { GetGeneralSettingResponse } from '@/modules/client-setting/type'

interface TransactionSettingListingProps {
	data: GetGeneralSettingResponse
}

export default function TransactionSettingListing({
	data,
}: TransactionSettingListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title="ตั้งค่าธุรกรรม"
					description="จัดการการตั้งค่าฝาก ถอน โอน และเทิร์นโอเวอร์"
				/>
			</div>
			<Separator />
			<TransactionSettingBox data={data} />
		</div>
	)
}
